import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const BILLING: AppRouteRecordRaw = {
  path: '/billing',
  name: 'billing',
  component: DEFAULT_LAYOUT,
  redirect: '/billing/electricity',
  meta: {
    locale: '计费管理',
    requiresAuth: true,
    icon: 'icon-money',
    order: 5,
  },
  children: [
    {
      path: 'electricity',
      name: 'ElectricityBilling',
      component: () => import('@/views/billing/electricity/index.vue'),
      meta: {
        locale: '费用与账单',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'template',
      name: 'BillingTemplate',
      component: () => import('@/views/billing/template/index.vue'),
      meta: {
        locale: '计费模板',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'batch',
      name: 'BillingBatch',
      component: () => import('@/views/billing/batch/index.vue'),
      meta: {
        locale: '计费下发',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default BILLING;
